<template>
  <h1 class="font-bold text-gray-900 text-4xl sm:text-5xl text-center mb-12">
    <slot />
  </h1>
</template>
